import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://gwjpdyuauvjttfewdnyl.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3anBkeXVhdXZqdHRmZXdkbnlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzMTM2MjMsImV4cCI6MjA1Nzg4OTYyM30.ZhNo-Tad1GVJO9naAc7TnpUfLlZsUo80cFDhMhDZIP0';

export const supabase = createClient(supabaseUrl, supabaseKey);